<form class="w100" [formGroup]="basicForm">
    <div class="row gap-8 avatareditarea">
        <rr-user-avatar [user]="user" class="avatar"></rr-user-avatar>
        <rr-icon name="edit" class="edit" (click)="editAvatar()"></rr-icon>
    </div>
    <div class="contentarea row gap-32 w100">
        <div class="col gap-16 leftside">
            <h3>{{ user.prename || user.email }} {{ user.lastname || "" }}</h3>
            <rr-input label="First Name" formControlName="prename"></rr-input>
            <rr-input label="Last Name" formControlName="lastname"></rr-input>
            <rr-select
                label="Intended Role"
                [options]="intentionRoleOptions"
                optionName="name"
                formControlName="intentionRoleId"
                optionValue="id"
            ></rr-select>
            <rr-select
                label="Chat Language"
                [options]="languageOptions"
                optionName="name"
                formControlName="lang"
                optionValue="id"
            ></rr-select>
            <div class="col w100">
                <div class="row changeemail space-between w100">
                    <div class="row align-center">
                        <rr-icon name="email" class="circle"></rr-icon>
                        <div class="col">
                            <div class="small strong" i18n>Email</div>
                            <span i18n class="tiny"
                                >Your email address is {{ user.email }}</span
                            >
                        </div>
                    </div>
                    <span
                        i18n
                        class="link changelink"
                        (click)="changeEmailShow()"
                        >Change</span
                    >
                </div>
                <div class="row changeemail space-between w100">
                    <div class="row align-center">
                        <rr-icon name="locked" class="circle"></rr-icon>
                        <div class="col">
                            <div class="small strong" i18n>Change Password</div>
                            <span i18n class="tiny"
                                >Change your password to keep your account
                                secure.</span
                            >
                        </div>
                    </div>
                    <span
                        i18n
                        class="link changelink"
                        (click)="changePasswordShow()"
                        >Change</span
                    >
                </div>
                <div class="row changeemail space-between w100">
                    <div class="row align-center">
                        <rr-icon name="trash" class="circle"></rr-icon>
                        <div class="col">
                            <div class="small strong" i18n>Delete Account</div>
                            <span i18n class="tiny">Delete your Account.</span>
                        </div>
                    </div>
                    <span
                        i18n
                        class="link changelink deletelink"
                        (click)="deleteAccount()"
                        >Delete</span
                    >
                </div>
                <!-- <div class="row privacy space-between w100">
                    <div class="row align-center">
                        <rr-icon name="alert" class="circle"></rr-icon>
                        <div class="col">
                            <div class="small strong" i18n>
                                Privacy Preferences
                            </div>
                            <span i18n class="tiny"
                                >These settings are tied to your browser</span
                            >
                        </div>
                    </div>
                    <span class="link changelink">Manage</span>
                </div> -->
            </div>
        </div>
        <div class="col rightside">
            <h3 i18n>About My Startup</h3>
            <app-basicinfos
                class="w100"
                [companyData]="user.companyData"
                (companyChange)="changeCompanyData($event)"
                [lang]="basicForm.value.lang || user.lang"
            ></app-basicinfos>
            <div
                class="row changeemail space-between w100"
                *ngIf="companyOwner"
            >
                <div class="row align-center">
                    <rr-icon name="locked" class="circle"></rr-icon>
                    <div class="col">
                        <div class="small strong" i18n>Delete Company</div>
                        <span i18n class="tiny">Delete your Company.</span>
                    </div>
                </div>
                <span i18n class="link changelink" (click)="deleteCompany()"
                    >Delete</span
                >
            </div>
        </div>
    </div>
</form>
